import { FormatUtils } from "@front/volcanion/utils"

class Callbacks {
  static filterToFormHandler(codeIntlPhone) {
    return function filterToForm(filter) {
      if (_.get(filter, 'auth.gsm'))
        _.merge(filter, {
          auth: {
            gsm: FormatUtils.parsePhoneNumber(_.get(filter, 'auth.gsm'), `+${codeIntlPhone}`)
          }
        })
      return {
        status: ['active', 'deleted', 'suspended'],
        ...filter,
      }
    }
  }
  static formToFilterHandler(codeIntlPhone) {
    return function formToFilter(values, extra, meta, state) {
      const { status, createdAt, ...rest } = values || {}
      return _.merge({},
        rest,
        { customerinfo: { '!': null } },
        !_.isEmpty(status) && { auth: FormatUtils.getParseFilterStatus(status) },
        !!createdAt && { createdAt: FormatUtils.intervalFilter(createdAt?.start, createdAt?.end) },
        !!rest?.auth?.gsm && { auth: { gsm: FormatUtils.parsePhoneNumber(values.auth.gsm, `+${codeIntlPhone}`) } },
        !!rest?.customerinfo?.name && { customerinfo: { name: { contains: values?.customerinfo?.name } } },
        !!rest?.info?.last_name && { info: { last_name: { startsWith: values?.info?.last_name } } },
        !!rest?.info?.first_name && { info: { first_name: { startsWith: values?.info?.first_name } } },
        !!rest?.auth?.email && { auth: { email: { contains: values?.auth?.email } } },
      )
    }
  }
}

export default Callbacks

